import { render } from "./UnitTypes.vue?vue&type=template&id=70de5694&scoped=true"
import script from "./UnitTypes.vue?vue&type=script&lang=js"
export * from "./UnitTypes.vue?vue&type=script&lang=js"

import "./UnitTypes.vue?vue&type=style&index=0&id=70de5694&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70de5694"]])

export default __exports__